export const updateObjectKey = (origin, oldKey, newKey) => {
  delete Object.assign(origin, { [newKey]: origin[oldKey] })[oldKey];
};
